<template>
  <vs-popup
    title=""
    class="associados117"
    :active.sync="modalAssociadoEmpresa117"
    @close="closeModal"
  >
    <div class="p-5">
      <vs-alert
        v-if="['aprovarVistoria', 'listarHibridos'].includes(acao)"
        class="alertAssociadoBaseAntiga"
        color="danger"
      >
        <div class="flex gap-3 pl-4">
          <vs-icon
            icon-pack="feather"
            icon="icon-alert-circle"
            size="small"
          ></vs-icon>
          <div>
            <h6 class="font-bold">Alerta</h6>
            <div class="sm:flex gap-1">
              <h6>Encontramos associado(s)</h6>
              <h6 class="font-bold">com o mesmo CPF</h6>
              <h6>no sistema antigo.</h6>
            </div>
          </div>
        </div>
      </vs-alert>

      <vs-alert
        v-if="acao == 'notificacaoDashboard'"
        class="alertAssociadoBaseAntiga"
        color="danger"
      >
        <div class="flex gap-3 pl-4">
          <vs-icon
            icon-pack="feather"
            icon="icon-alert-circle"
            size="small"
          ></vs-icon>
          <div>
            <h6 class="font-bold">Alerta</h6>
            <div class="sm:flex gap-1">
              <h6>
                O Associado assinou o termo de inclusão, para incluir os
                veículos na Bem Protege, é necessário alterar o status do
                associado e do(s) veiculo(s) abaixo no sistema antigo
              </h6>
            </div>
          </div>
        </div>
      </vs-alert>

      <div
        class="flex gap-2 mt-4 items-end"
        v-if="acao == 'notificacaoDashboard'"
      >
        <h6 style="color: red">
          Confirme se já atualizou o status clicando em
          <vs-icon color="#158C12" icon="thumb_up"></vs-icon>
        </h6>
      </div>

      <div v-for="item in veiculosAssociado117" :key="item.id" class="mt-5">
        <vx-card>
          <ul>
            <li>
              <p class="w-1/5 font-semibold">Nome:</p>
              <p>{{ item.nome }}</p>
            </li>
            <li>
              <p class="w-1/5 font-semibold">CPF:</p>

              <p>{{ item.cpfcnpj }}</p>
            </li>
            <li>
              <p class="lg:w-1/5 font-semibold">Placa(s):</p>

              <ul>
                <li
                  class="p-0 flex justify-between gap-2 mb-1"
                  v-for="veiculos in item.veiculos"
                  :key="veiculos.id"
                >
                  <p class="flex items-center">
                    {{ veiculos.placa }}
                  </p>

                  <vs-chip
                    v-if="['aprovarVistoria', 'listarHibridos'].includes(acao)"
                    :color="getSituacaoVeiculoColor(veiculos.situacaoVeiculo)"
                    class="chipSituacaoVeiculo rounded"
                  >
                    {{ veiculos.situacaoVeiculo }}
                  </vs-chip>

                  <div
                    class="buttonAlteracaoStatus"
                    v-if="acao == 'notificacaoDashboard'"
                  >
                    <vs-button
                      color="#158C12"
                      @click.stop.prevent="
                        alteracaoStatusManual(veiculos.idVeiculo)
                      "
                      icon="thumb_up"
                    ></vs-button>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </vx-card>
      </div>

      <div class="mt-5 flex justify-between">
        <vs-button
          color="#FF1800"
          class="p-4"
          @click.stop.prevent="desconsiderar()"
        >
          <h6 v-if="acao == 'notificacaoDashboard'" style="color: white">
            Lembrar mais tarde
          </h6>
          <h6 v-else style="color: white">
            Desconsiderar e não incluir
          </h6></vs-button
        >
        <vs-button
          v-if="acao != 'notificacaoDashboard'"
          color="#158C12"
          class="p-4"
          @click.stop.prevent="inclusaoBptech()"
        >
          <h6 style="color: white">Incluir veículos no BPTECH</h6></vs-button
        >
      </div>
    </div>
  </vs-popup>
</template>

<script>
import VxCard from '../../components/vx-card/VxCard.vue';
import service from '../../services';

export default {
  components: { VxCard },
  name: 'ModalVeiculosEmpresaAntiga',

  props: ['dadosVeiculosEmpresaAntiga'],

  data() {
    return {
      veiculosAssociado117: [],
      modalAssociadoEmpresa117: false,
      acao: null,
    };
  },

  watch: {
    dadosVeiculosEmpresaAntiga() {
      if (this.dadosVeiculosEmpresaAntiga.acao) {
        this.acao = this.dadosVeiculosEmpresaAntiga.acao;
        this.verificaAssociado118na117(this.dadosVeiculosEmpresaAntiga.id);
      }
    },
  },

  methods: {
    verificaAssociado118na117(idProspect) {
      this.$vs.loading();
      var objSend = {};

      objSend.idEmpresaAntiga = 117;
      objSend.idProspect = idProspect;

      service
        .post('Veiculos', 'buscaVeiculosAssociadoEmpresaAntiga', objSend)
        .then((res) => {
          const obj = res.data;

          if (obj.length > 0) {
            this.veiculosAssociado117 = {};
            obj.forEach((element) => {
              const {
                idVeiculo,
                cpfcnpj,
                nome,
                placa,
                chassi,
                situacaoVeiculo,
              } = element;

              if (nome in this.veiculosAssociado117) {
                this.veiculosAssociado117[nome].veiculos.push({
                  idVeiculo,
                  placa,
                  chassi,
                  situacaoVeiculo,
                });
              } else {
                this.veiculosAssociado117[nome] = {
                  cpfcnpj,
                  nome,
                  veiculos: [{ idVeiculo, placa, chassi, situacaoVeiculo }],
                };
              }
            });
            this.modalAssociadoEmpresa117 = true;
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
            this.modalAssociadoEmpresa117 = false;
            this.$emit('resposta', this.acao);
          }
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },

    setNecessitaMigracao(index) {
      this.$vs.loading();
      const objSend = {
        iniciouMigracao: true,
        idsVeiculos: [],
      };

      Object.values(index).forEach((obj) => {
        if (obj.veiculos) {
          obj.veiculos.forEach((veiculo) => {
            objSend.idsVeiculos.push(veiculo.idVeiculo);
          });
        }
      });

      service
        .post('Veiculos', 'migracaoHibrido', objSend)
        .then(() => {
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    getSituacaoVeiculoColor(data) {
      if (data == 'ATIVO') return '#158C12';
      if (data == 'INADIMPLENTE') return '#FF1800';
      if (data == 'INATIVO') return 'dark';
      return 'danger';
    },
    alteracaoStatusManual(id) {
      const objSend = {};
      objSend.idVeiculo = id;
      this.$vs.loading();
      service
        .post('Veiculos', 'alteracaoStatusManual', objSend)
        .then(() => {
          this.verificaAssociado118na117();

          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    inclusaoBptech() {
      this.setNecessitaMigracao(this.veiculosAssociado117);
      this.modalAssociadoEmpresa117 = false;
      this.$emit('resposta', this.acao);
    },
    desconsiderar() {
      this.modalAssociadoEmpresa117 = false;
      this.$emit('resposta', this.acao);
    },
    closeModal() {
      this.modalAssociadoEmpresa117 = false;
      this.$emit('resposta', 'closeModal');
    },
  },
};
</script>
<style scoped>
.alertAssociadoBaseAntiga {
  height: auto !important;
  border-radius: 15px;
  padding: 10px 0;
}
.associados117 h6 {
  letter-spacing: 0;
  font-size: 12px;
}
.associados117 p {
  letter-spacing: 0;
  font-size: 12px;
}
.associados117 li {
  display: flex;
  padding: 10px;
  gap: 4px;
}
.associados117 ul > li:nth-of-type(odd) {
  background-color: #f1f1f1;
  border-radius: 5px;
}
.associados117 .vs-button {
  border-radius: 15px;
}
.chipSituacaoVeiculo.con-vs-chip {
  min-height: 0;
}
</style>
<style>
.associados117 .vs-popup--header {
  background: none;
}
.buttonAlteracaoStatus .vs-button {
  border-radius: 50px !important;
  width: auto !important;
  height: auto !important;
}
.associados117.con-vs-popup .vs-popup {
  z-index: 99999 !important;
}
</style>
